import Vue from 'vue'
import VueResource from 'vue-resource'

import { updateAuthHeader } from './helper'
import {
  admin,
  device,
  devices,
  exports,
  firmwareDelete,
  firmwareList,
  firmwareUpload,
  geolocation,
  image,
  infoModel,
  legal,
  notifications,
  onlineTesting,
  reset,
  session,
  serviceConfig,
  theme,
  tsdb,
  total,
  user,
  users
} from './resources'

Vue.use(VueResource)

export const plugin = {}
plugin.install = function (Vue, options) {
  if (localStorage.token) {
    updateAuthHeader(Vue, localStorage.token)
  }

  Vue.prototype.$api = {
    addFirmware (data) {
      return firmwareUpload.save({}, data)
    },
    addNotification (data) {
      return notifications.save({}, data)
    },
    exportData (data) {
      return exports.save(data)
    },
    checkToken () {
      return admin.get()
    },
    getGeoip (ip) {
      if (!ip || ip === 'none') {
        return Promise.resolve({
          country_name: '--',
          region_name: '--'
        })
      }

      const fields = 'country,city'
      return geolocation.get({ ip, fields })
        .then(({ body: { country, city } }) => ({
          country_name: country || '--',
          region_name: city || '--'
        }))
        .catch(() => ({
          country_name: '--',
          region_name: '--'
        }))
    },
    getDevices (query) {
      return devices.get(query)
    },
    getInfoModels () {
      return infoModel.get()
    },
    getLegal () {
      return legal.get()
    },
    getLogs (query) {
      return tsdb.get(query)
    },
    getFirmwareList () {
      return firmwareList.get()
    },
    getNotification (id) {
      return notifications.get({ id })
        .then(({ data }) => data)
    },
    getNotificationsList () {
      return notifications.get()
        .then(({ data }) => data)
    },
    getServiceConfig (service) {
      return serviceConfig.get(service)
    },
    getTheme () {
      return theme.get()
    },
    getTotal (query) {
      return total.get(query)
    },
    getUsers (query) {
      return users.get(query)
    },
    getUser (id) {
      return user.get(id)
    },
    login (params) {
      return session.save({}, params)
        .then(res => {
          const token = res.data.token
          const id = res.data.id
          updateAuthHeader(Vue, token)
          return { id, token }
        })
    },
    lockDevice (id) {
      return device.delete({ id }, { headers: { 'content-type': 'application/json' } })
    },
    removeFirmware (data) {
      return firmwareDelete.save({}, data)
    },
    removeInfoModelImages (data) {
      return image.delete({}, data)
    },
    removeInfoModel (data) {
      return infoModel.delete({}, data)
    },
    removeNotification (id) {
      return notifications.delete({ id }, { headers: { 'content-type': 'application/json' } })
    },
    removeUser (id) {
      return user.delete({ id }, { headers: { 'content-type': 'application/json' } })
    },
    resetPassword (email) {
      return reset.save({}, { email })
    },
    activeUser (code) {
      return users.save({}, { code })
    },
    triggerOnlineTesting (data) {
      return onlineTesting.save({}, data)
    },
    updateInfoModelImages (data) {
      return image.save({}, data)
    },
    updateInfoModel (data) {
      return infoModel.update(data)
    },
    updateLegal (data) {
      return legal.update(data)
    },
    updateNotification (data) {
      return notifications.update(data)
    },
    updatePassword (code, password) {
      return reset.update({
        new_password: password,
        reset_token: code
      })
    },
    updateServiceConfig (service, data) {
      return serviceConfig.save({ service }, data)
    },
    updateTheme (form) {
      return theme.save(form)
    }
  }
}

export default plugin



// WEBPACK FOOTER //
// ./src/api/plugin.js